import {
  defaultGoJsLayeredDigraphLayoutSettings,
  getDefaultSettingsForLayoutType,
} from 'src/containers/ProjectDiagram/templates/extensions/layouts/constants';
import { ExtendedForceDirectedLayout } from 'src/containers/ProjectDiagram/templates/extensions/layouts/ForceDirectedLayout/ExtendedForceDirectedLayout';
import { ExtendedLayeredDigraphLayout } from 'src/containers/ProjectDiagram/templates/extensions/layouts/LayeredLayout/ExtendedLayeredDigraphLayout';
import { LayoutAlgorithmType } from 'src/containers/ProjectDiagram/templates/extensions/layouts/types';

export const layoutAlgorithmSetup = (
  layoutAlgorithm: LayoutAlgorithmType = LayoutAlgorithmType.D3_FORCE_LAYOUT
): ExtendedForceDirectedLayout | ExtendedLayeredDigraphLayout => {
  const layoutSettings = getDefaultSettingsForLayoutType(layoutAlgorithm);
  const props = { layoutSettings };

  switch (layoutAlgorithm) {
    case LayoutAlgorithmType.D3_FORCE_LAYOUT:
      return new ExtendedForceDirectedLayout(props);
    case LayoutAlgorithmType.GO_JS_HORIZONTAL_LAYERED_DIGRAPH_LAYOUT:
      return new ExtendedLayeredDigraphLayout({
        ...props,
        layoutSettings: {
          ...defaultGoJsLayeredDigraphLayoutSettings,
          ...(props.layoutSettings || {}),
          direction: 0,
        },
      });
    case LayoutAlgorithmType.GO_JS_VERTICAL_LAYERED_DIGRAPH_LAYOUT:
      return new ExtendedLayeredDigraphLayout({
        ...props,
        layoutSettings: {
          ...defaultGoJsLayeredDigraphLayoutSettings,
          ...(props.layoutSettings || {}),
          direction: 90,
        },
      });
    default:
      throw new Error(`Unknown layout algorithm type: ${layoutAlgorithm}`);
  }
};
